import { memo } from "react";
import { TextBoldIcon, TextStrikeIcon } from "@/icons/widget-menu";
import { HStack } from "@/shared/ui/Stack";
import { MenuButton } from "../MenuButton/MenuButton";

interface TextFormatMenuContentProps {
    onTextBoldButtonClick: () => void;
    onTextStrikeButtonClick: () => void;
}

export const TextFormatMenuContent = memo(function TextFormatMenuContent({
    onTextBoldButtonClick,
    onTextStrikeButtonClick,
}: TextFormatMenuContentProps) {
    return (
        <HStack gap={2}>
            <MenuButton onClick={onTextBoldButtonClick}>
                <TextBoldIcon />
            </MenuButton>

            <MenuButton onClick={onTextStrikeButtonClick}>
                <TextStrikeIcon />
            </MenuButton>
        </HStack>
    );
});
